import axios from 'axios'

const Data = {
  get (dataset) {
    if (dataset === Data.dataset && Data.dataContent) {
      return Promise.resolve(Data.dataContent)
    }
    return axios({ method: 'GET', 'url': 'https://4aszj99tzj.execute-api.us-east-2.amazonaws.com/default/showroomGetData?dataset=' + dataset })
      .then(result => {
        Data.dataset = dataset
        Data.dataContent = result.data
        return Data.dataContent
      }, error => {
        console.error('error while calling dataset data:' + dataset)
        console.error(error)
        return error
      })
  }
}

export default Data



// WEBPACK FOOTER //
// ./src/components/Data.js